<template>
  <div class="row justify-content-md-center">
    <div class="col-xl-3"></div>
    <div class="col-xl-6 col-center">
      <section class="container-fluid white-box">
        <div class="row">
          <div class="col-md-12">
            <h2>Congratulations!</h2>
            <p class="sub-text">
              We've received your signup request and will contact you soon!
            </p>
          </div>
          <div class="col-md-12 d-flex justify-content-end">
            <button
              class="back-button dark-button mt-0"
              type="button"
              name="next"
              @click="newClicked"
            >
              Go back
            </button>
          </div>
        </div>
      </section>
    </div>
    <div class="col-xl-3"></div>
  </div>
</template>

<script>
import { DASHBOARD_URL } from "@/constants";

export default {
  name: "CompletePage",
  components: {},
  props: {
    showDashboardUrl: Boolean,
  },
  data() {},
  methods: {
    newClicked() {
      this.$router.push("/wait-list/");
    },
  },
  mounted() {},
  created() {},
  computed: {
    dashboardURL() {
      return DASHBOARD_URL;
    },
  },
  watch: {},
};
</script>

<style scoped>
button {
  /* margin-left: 24px;
  margin-top: 24px; */
  /*margin-left: 2.22vh;*/
  margin-top: 2.22vh;
}

.dashboard-link {
  background: #ff4f21;
  box-shadow: 0px 1px 3px #00000033;
  border-radius: 4px;
  color: #fff;
  /* padding: 18px 22px; */
  vertical-align: middle;
}

a {
  vertical-align: middle;
  text-align: center;
}

.row {
  padding-bottom: 0px !important;
}
</style>
